import { apiSlice } from "../../app/api/apiSlice";

export const evaluationSessionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvaluationSessions: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/evaluation_sessions/",
        params,
      }),
      providesTags: ["EvaluationSession"],
    }),
    fetchEvaluationSessionById: builder.query({
      query: (id) => `/api/v1/resources/evaluation_sessions/${id}/`,
      providesTags: (result, error, id) => [{ type: "EvaluationSession", id }],
    }),
    createEvaluationSession: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/evaluation_sessions/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["EvaluationSession"],
    }),
    deleteEvaluationSession: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/evaluation_sessions/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["EvaluationSession"],
    }),
  
    getEvaluationSessionsDetail: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/evaluation_sessions/detailed/",
        params,
      }),
      providesTags: ["EvaluationSession"],
    }),
    createEvaluationSessionForAll: builder.mutation({
      query: (args) => ({
        url: `/api/v1/resources/evaluation_sessions/eval_all_sessions/`,
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["EvaluationSession"],
    }),
  
    getPartnerEvaluatedSessions: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/partner_evaluation_sessions/",
        params,
      }),
      providesTags: ["EvaluationSession"],
    }),
    fetchPartnerEvaluatedSessionById: builder.query({
      query: (id) => `/api/v1/resources/partner_evaluation_sessions/${id}/`,
      providesTags: (result, error, id) => [{ type: "EvaluationSession", id }],
    }),

    getAlignmentAnalytics: builder.query({
      query: () => "/api/v1/analytics/alignment-stats/",
      providesTags: ["EvaluationSession"], 
    }),
    getPKSalesAlignment: builder.query({
      query: () => "/api/v1/analytics/pk-alignment-stats/",
      providesTags: ["EvaluationSession"],
    }),
  }),
});

export const {
  useGetEvaluationSessionsQuery,
  useFetchEvaluationSessionByIdQuery,
  useCreateEvaluationSessionMutation,
  useDeleteEvaluationSessionMutation,

  useGetEvaluationSessionsDetailQuery,
  useCreateEvaluationSessionForAllMutation,

  useGetPartnerEvaluatedSessionsQuery,
  useFetchPartnerEvaluatedSessionByIdQuery,
  
  useGetAlignmentAnalyticsQuery,
  useGetPKSalesAlignmentQuery,
} = evaluationSessionsApiSlice;
